/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Button, Grid, Form, Divider, Dropdown, Segment, Dimmer, Loader } from "semantic-ui-react";
import MonitoringReport from "./MonitoringReport";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

export const getDefaultFiber = () => ({
  FB1: {
    channel2: 0,
    channel3: 0,
    signal: false,
    statusChannel2: "",
    statusChannel3: ""
  },
  FB2: {
    channel2: 0,
    channel3: 0,
    signal: false,
    statusChannel2: "",
    statusChannel3: ""
  }
});

export const getDefaultFiberChannelActive = () => ({
  FB1: {
    channel2Active: false,
    channel3Active: false,
    signalActive: false
  },
  FB2: {
    channel2Active: false,
    channel3Active: false,
    signalActive: false
  }
});

export const normalizeFiber = (fiber) => ({
  FB1: {
    ...getDefaultFiber().FB1,
    ...(fiber && typeof fiber.FB1 === "object" ? fiber.FB1 : {})
  },
  FB2: {
    ...getDefaultFiber().FB2,
    ...(fiber && typeof fiber.FB2 === "object" ? fiber.FB2 : {})
  }
});

export const normalizeFiberChannelActive = (fiberChannelActive) => ({
  FB1: {
    ...getDefaultFiberChannelActive().FB1,
    ...(fiberChannelActive && typeof fiberChannelActive.FB1 === "object" ? fiberChannelActive.FB1 : {})
  },
  FB2: {
    ...getDefaultFiberChannelActive().FB2,
    ...(fiberChannelActive && typeof fiberChannelActive.FB2 === "object" ? fiberChannelActive.FB2 : {})
  }
});

const dropdownOptions = [
  {
    key: Constants.CONFORM,
    value: Constants.CONFORM,
    text: Strings.CONFORM_STRING
  },
  {
    key: Constants.CONFORM_W_RESTRICTION,
    value: Constants.CONFORM_W_RESTRICTION,
    text: Strings.CONFORM_W_RESTRICTION_STRING
  },
  {
    key: Constants.NON_CONFORM,
    value: Constants.NON_CONFORM,
    text: Strings.NON_CONFORM_STRING
  }
];

class Report extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isGenerateReportDimmerActive: false,

      savedClients: [],
      savedExecutors: [],

      // User input data
      clientProjectName: "",
      clientNetworkName: "",
      clientLocation: "",
      clientCompanyName: "",
      clientAccountableName: "",
      clientAddress: "",
      clientCity: "",
      clientTel: "",
      executingCompanyName: "",
      executingAccountableName: "",
      executingTel: "",
      executingEmail: "",
      notes: "",
      conformity: "",
      // The report
      report: ""
    };
  }

  setGeneratingDimmerState = (isActive) => {
    if (!isActive) {
      this.setState({ isGenerateReportDimmerActive: isActive }, () => {
        alert(Strings.GENERATING_REPORT_SUCCESS);
      });
    }
    else {
      this.setState({ isGenerateReportDimmerActive: isActive });
    }
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Data retrieval functions ----------------
  retrieveMonitoringData = async (userInput) => {
    this.setGeneratingDimmerState(true);

    let livelist = await fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
      .then(res => res.json())
      .then(data => data.sort(UtilsInstance.sortBy("address", false, parseInt)));

    let log = await fetch(Constants.REQUEST_IP_ADDRESS + "log", { mode: "cors" })
      .then(res => res.json())
      .then(data => data);

    let uptime = await fetch(Constants.REQUEST_IP_ADDRESS + "homePage", { mode: "cors" })
      .then(res => res.json())
      .then(data => data.uptime);

    let deviceStatistics = await fetch(Constants.REQUEST_IP_ADDRESS + "deviceStatistics", { mode: "cors" })
      .then(res => res.json())
      .then(data => data.deviceStatistics);

    let networkStatistics = await fetch(Constants.REQUEST_IP_ADDRESS + "networkStatistics", { mode: "cors" })
      .then(res => res.json())
      .then(data => data.networkStatistics);

    let trafficStatistics = await fetch(Constants.REQUEST_IP_ADDRESS + "trafficStatistics", { mode: "cors" })
      .then(res => res.json())
      .then(data => data);

    let configData = await fetch(Constants.REQUEST_IP_ADDRESS + "config", { mode: "cors" })
      .then(res => res.json())
      .then(data => data);

    let wifiStatus = await fetch(Constants.REQUEST_IP_ADDRESS + "wifiStatus", { mode: "cors" })
      .then(res => res.json())
      .then(data => data.status);

    let fiber;
    let fiberChannelActive;
    
    if (sessionStorage.getItem("isFiberProcessOn") === "true") {
      fiber = await fetch(Constants.REQUEST_IP_ADDRESS + "fiber", { mode: "cors" })
        .then(UtilsInstance.checkStatus)  
        .then(res => res.json())
        .then(normalizeFiber)
        .catch(() => {
          return getDefaultFiber();
        });

      fiberChannelActive = await fetch(Constants.REQUEST_IP_ADDRESS + "fiber/fiberChannelActive", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(normalizeFiberChannelActive)
        .catch(() => {
          return getDefaultFiberChannelActive();
        });
    } else {
      fiber = getDefaultFiber();
      fiberChannelActive = getDefaultFiberChannelActive();
    }

    let wifiConfigData = "";

    if (wifiStatus === Constants.CONNECTED_STATUS) {
      wifiConfigData = await fetch(Constants.REQUEST_IP_ADDRESS + "wifiConfig", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);
    }
    else {
      wifiConfigData = {
        "wifiMode": "",
        "hiddenSSID": false,
        "wifiName": "",
        "wifiAddr": "",
        "wifiNetmask": "",
        "wifiGateway": "",
        "wifiDNS": "",
        "wifiPwd": ""
      };
    }

    let tag = await fetch(Constants.REQUEST_IP_ADDRESS + "tag", { mode: "cors" })
      .then(res => res.json())
      .then(data => data.tag);

    let graphicNetworkStatus = await fetch(Constants.REQUEST_IP_ADDRESS + "graphicNetworkStatus", { mode: "cors" })
      .then(res => res.json())
      .then(data => data);

    let availability = graphicNetworkStatus.percentageAvailable + graphicNetworkStatus.percentageDiagnostic;
    availability = availability.toFixed(0).concat("%");

    this.setState({
      report: <MonitoringReport
        userInput={userInput}
        livelist={livelist}
        log={log}
        uptime={uptime}
        deviceStatistics={deviceStatistics}
        networkStatistics={networkStatistics}
        trafficStatistics={trafficStatistics}
        configData={configData}
        tag={tag}
        wifiConfigData={wifiConfigData}
        availability={availability}
        conformity={this.state.conformity}
        fiber={fiber}
        fiberChannelActive={fiberChannelActive}
      />
    });
  }

  // ----------------- Event Handlers -----------------
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleConformityDropdownItemClick = (event, info) => {
    this.setState({ conformity: info.value });
  }

  handleSubmit = () => {
    let clientImg = "";
    let executorImg = "";

    if (document.getElementById("client-img").files[0] !== undefined) {
      clientImg = URL.createObjectURL(document.getElementById("client-img").files[0]);
    }

    if (document.getElementById("executor-img").files[0] !== undefined) {
      executorImg = URL.createObjectURL(document.getElementById("executor-img").files[0]);
    }

    this.setState({ report: "" }, () => {
      let userInput = {
        // Client info
        clientProjectName: this.state.clientProjectName,
        clientNetworkName: this.state.clientNetworkName,
        clientLocation: this.state.clientLocation,
        clientCompanyName: this.state.clientCompanyName,
        clientAccountableName: this.state.clientAccountableName,
        clientAddress: this.state.clientAddress,
        clientCity: this.state.clientCity,
        clientTel: this.state.clientTel,
        clientImg: clientImg,
        // Executing company info
        executingCompanyName: this.state.executingCompanyName,
        executingAccountableName: this.state.executingAccountableName,
        executingTel: this.state.executingTel,
        executingEmail: this.state.executingEmail,
        executorImg: executorImg,
        // Notes
        notes: this.state.notes,
        // Conformity
        conformity: this.state.conformity
      };

      this.retrieveMonitoringData(userInput);
    });

  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
  }

  render() {
    const {
      clientProjectName,
      clientNetworkName,
      clientLocation,
      clientCompanyName,
      clientAccountableName,
      clientAddress,
      clientCity,
      clientTel,
      executingCompanyName,
      executingAccountableName,
      executingTel,
      executingEmail,
      notes
    } = this.state;

    return (
      <div style={divStyle}>

        <Grid columns={2} doubling stretched>
          <Grid.Column>
            <Segment>

              <Divider horizontal>{Strings.CLIENT_INFO}</Divider>

              <Form>
                <Form.Input label={Strings.PROJECT_NAME_LABEL} name='clientProjectName' value={clientProjectName} onChange={this.handleChange} />
                <Form.Input label={Strings.NETWORK_LABEL} name='clientNetworkName' value={clientNetworkName} onChange={this.handleChange} />
                <Form.Input label={Strings.LOCATION_LABEL} name='clientLocation' value={clientLocation} onChange={this.handleChange} />
                <Form.Input label={Strings.COMPANY_NAME_LABEL} name='clientCompanyName' value={clientCompanyName} onChange={this.handleChange} />
                <Form.Input label={Strings.ACCOUNTABLE_NAME_LABEL} name='clientAccountableName' value={clientAccountableName} onChange={this.handleChange} />
                <Form.Input label={Strings.ADDRESS} name='clientAddress' value={clientAddress} onChange={this.handleChange} />
                <Form.Input label={Strings.CITY_LABEL} name='clientCity' value={clientCity} onChange={this.handleChange} />
                <Form.Input label={Strings.TEL_LABEL} name='clientTel' value={clientTel} onChange={this.handleChange} />
                <Form.Input id="client-img" label={Strings.CLIENT_LOGO_LABEL} type="file" accept=".png,.jpg,.jpeg" />
              </Form>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment>

              <Divider horizontal>{Strings.EXECUTING_COMPANY_INFO}</Divider>

              <Form>
                <Form.Input label={Strings.COMPANY_NAME_LABEL} name='executingCompanyName' value={executingCompanyName} onChange={this.handleChange} />
                <Form.Input label={Strings.ACCOUNTABLE_NAME_LABEL} name='executingAccountableName' value={executingAccountableName} onChange={this.handleChange} />
                <Form.Input label={Strings.TEL_LABEL} name='executingTel' value={executingTel} onChange={this.handleChange} />
                <Form.Input label={Strings.EMAIL_LABEL} name='executingEmail' value={executingEmail} onChange={this.handleChange} />
                <Form.Input id="executor-img" label={Strings.EXECUTING_COMPANY_LOGO_LABEL} type="file" accept=".png,.jpg,.jpeg" />
              </Form>
            </Segment>

            <Segment>
              <Divider horizontal>{Strings.CONFORMITY}</Divider>
              <Dropdown
                fluid
                selection
                placeholder={Strings.DROPDOWN_PLACEHOLDER}
                options={dropdownOptions}
                onChange={this.handleConformityDropdownItemClick} />
            </Segment>

            <Segment>
              <Divider horizontal>{Strings.ANNOTATIONS}</Divider>
              <Form>
                <Form.Input type="text" name='notes' value={notes} onChange={this.handleChange} />
              </Form>
            </Segment>
          </Grid.Column>
        </Grid>

        <Button
          style={buttonStyle}
          color="teal"
          onClick={this.handleSubmit}>
          {Strings.GENERATE_REPORT}
        </Button>

        <PDFDownloadLink
          style={pdfLinkStyle}
          document={this.state.report}
          fileName={`${Strings.REPORT_EXPORT_NAME}.pdf`}>
          {({ loading }) => {
            if (loading) {
              return Strings.FINISHING;
            }
            else {
              if (this.state.isGenerateReportDimmerActive) {
                this.setGeneratingDimmerState(false);
              }
              return Strings.SAVE_REPORT;
            }
          }}
        </PDFDownloadLink>

        <div id="chart" style={chartsStyle}></div>
        <div id="barchart" style={chartsStyle}></div>

        <Dimmer page active={this.state.isGenerateReportDimmerActive} >
          <Loader size="big">{Strings.GENERATING_REPORT_WAITING}</Loader>
        </Dimmer>

      </div>
    );
  }
}

const chartsStyle = {
  width: "80vw",
  height: "30vh",
  display: "none",
  visibility: "hidden"
};

const divStyle = {
  margin: "2vh 2vw",
  textAlign: "center"
};

const buttonStyle = {
  margin: "2vh auto"
};

const pdfLinkStyle = {
  marginLeft: "2vw"
};

export default withRouter(Report);